const LABEL_FORMATS = new Set(['PNG', 'PDF', 'ZPL', 'EPL2']);

export function normalizeLabelFormatHint(value?: string | null): string | null {
  const normalized = String(value || '').trim().toUpperCase();
  return LABEL_FORMATS.has(normalized) ? normalized : null;
}

export function buildPrintPath(labelUrl: string, labelFormat?: string | null): string {
  const params = new URLSearchParams({ src: labelUrl });
  const normalizedFormat = normalizeLabelFormatHint(labelFormat);
  if (normalizedFormat) params.set('format', normalizedFormat);
  return `/print?${params.toString()}`;
}

export function labelExtension(contentType: string, labelFormat?: string | null): string {
  const normalizedFormat = normalizeLabelFormatHint(labelFormat);
  if (['text/plain', 'application/octet-stream'].includes(contentType.toLowerCase())) {
    if (normalizedFormat === 'ZPL') return 'zpl';
    if (normalizedFormat === 'EPL2') return 'epl2';
  }
  switch (contentType.toLowerCase()) {
    case 'application/pdf':
      return 'pdf';
    case 'image/png':
      return 'png';
    case 'image/jpeg':
      return 'jpg';
    case 'image/gif':
      return 'gif';
    case 'image/webp':
      return 'webp';
    case 'text/plain':
    case 'application/octet-stream':
      return 'txt';
    default:
      return 'bin';
  }
}
